export enum ViewHeaderBackground {
  DARK = 'dark',
  LIGHT = 'light',
  TRANSPARENT = 'transparent',
}

export enum ViewHeaderType {
  BACK = 'back',
  CLOSE = 'close',
}
